import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, ModuleFE_MouseInteractivity, mouseInteractivity_ToolTip, openContent, TS_Table } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_PermissionAccessLevel, ModuleFE_PermissionDomain, ModuleFE_PermissionGroup } from '@nu-art/permissions-frontend/index';
import './Component_UserTypeInfo.scss';
import { PermissionGroupData_All } from '@app/shared/permissions/permission-groups';
import { _keys, filterDuplicates, flatArray, MUSTNeverHappenException } from '@nu-art/ts-common';
import { Const__ProjectName_KnowledgeManager } from '@app/hcs-shared';
const scopeNameMap = {
    knowledgeManager: Const__ProjectName_KnowledgeManager,
    advisor: 'Advisor',
};
const userTypeCol = 'User Type';
export class Component_UserTypeInfo extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.data = PermissionGroupData_All;
        return state;
    }
    // ######################## Logic ########################
    openPopUp = () => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_ToolTip);
        const model = {
            id: 'user-types-popup',
            content: this.renderPopUpContent,
            originPos: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
            modalPos: { x: 0, y: 0 },
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    // ######################## Render ########################
    renderToolTipContent = () => {
        return _jsxs(_Fragment, { children: ["Click to view table for user types under the ", _jsx("b", { children: scopeNameMap[this.props.scope] }), " scope"] });
    };
    renderPopUpContent = () => {
        const permissionGroups = this.state.data.map(groupData => {
            const permissionGroup = ModuleFE_PermissionGroup.cache.unique(groupData._id);
            if (!permissionGroup)
                throw new MUSTNeverHappenException(`Could not get permission group for id ${groupData._id}`);
            return permissionGroup;
        });
        const allDomainIds = filterDuplicates(flatArray(permissionGroups.map(group => _keys(group._levelsMap))));
        const headers = [userTypeCol, ...allDomainIds];
        return _jsx(TS_Table, { rows: permissionGroups, header: headers, cellRenderer: (col, row) => {
                if (col === userTypeCol)
                    return _jsx("div", { className: 'header', children: row.label });
                const accessLevel = ModuleFE_PermissionAccessLevel.cache.find(accessLevel => {
                    return accessLevel.domainId === col && row.accessLevelIds.includes(accessLevel._id);
                });
                const className = _className(accessLevel && accessLevel.name.toLowerCase());
                return _jsx("div", { className: className, children: accessLevel?.name ?? 'N/A' });
            }, headerRenderer: header => {
                if (header === userTypeCol)
                    return header;
                const domain = ModuleFE_PermissionDomain.cache.unique(header);
                return domain?.namespace;
            } });
    };
    render() {
        return _jsx("div", { className: 'user-permissions__info', ...openContent.tooltip.top('user-types-tooltip', this.renderToolTipContent, { offset: -5 }), onClick: this.openPopUp, children: "?" });
    }
}
